import AppLayout from "../AppLayout";
import QuickSearch from "../Home/Home";
import Login from "../../pages/Login";
import Logout from "../../pages/Logout";
import DRNUpload from "../DRNUpload/DRNUpload";
import MainHeader from "../PublicComponents/MainHeader";
import UnAuth from "../PublicComponents/UnAuth";
import { useUser } from "../../contexts/userContextApi";
import AdvancedSearch from "../AdvancedSearch/AdvancedSearch";
import TaxHome from "../TaxCertificate/TaxHome";
import {
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import QNAHome from "../Questionnaire/QNAHome";
import QuestionnairePage from "../Questionnaire/QuestionnairePage";
import { useEffect } from "react";
import Home from "../Home/Home";
import CustomRegForm from "../Vendor/CustomRegistration/CustomRegForm";
import ACHome from "../AnnualCertificate/ACHome";
import ContinuationPage from "../Vendor/CustomRegistration/ContinuationPage";
export default function AppContent() {
  const user = useUser();
  const { headerView, setHeaderView } = useUser();
  const location = useLocation();

  useEffect(() => {
    const isQuestionPage = location.pathname.startsWith(
      "/drn/questionnaire/question/"
    );

    setHeaderView(isQuestionPage);
  }, [location.pathname]);


  return (
    <>
      <MainHeader />

      <Routes>
        <Route
          path="/"
          element={<Login />}
        />

        <Route path="/drn" element={<AppLayout />}>
          {user?.role !== "itr_user" ? (
            <Route index element={<Navigate to="quickSearch" replace />} />
          ) : (
            <Route index element={<Navigate to="questionnaire" replace />} />
          )}

          <Route path="quickSearch" element={<Home/>} />
          <Route path="uploadDrn" element={<DRNUpload />} />
          <Route path="advancedSearch" element={<AdvancedSearch />} />
          <Route path="questionnaire" element={<QNAHome />} />
          <Route path="taxExemptionCertificates" element={<TaxHome/>} />
          <Route path="logout" element={<Logout />} />
          <Route path="annualCertificateSearch" element={<ACHome/>} />
         <Route
           path="questionnaire/question/:orderNumber"
            element={<QuestionnairePage />}
          />
        </Route>
        <Route path="/customRegForm" element={<CustomRegForm />} />
          <Route path="/information" element={<ContinuationPage />} />
        <Route path="/UnAuthorize" element={<UnAuth />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}